import { ApolloClient, NormalizedCacheObject } from '@apollo/client'

import { SuggestionsDocument } from 'hooks/useQueries'

type SuggestionsSsr = {
  suggestions?: unknown
}

// Seeds the "More Escapes" slider so it renders from the SSR payload instead of
// fetching client-side. The caller must pass the listingId exactly as that page's
// <Suggestions> consumer reads it (raw on the story page, stringified on the
// adventure page) so the seed shares the consumer's Apollo cache key.
// writeQuery is synchronous — safe in mini_racer SSR.
const seedSuggestions = (
  client: ApolloClient<NormalizedCacheObject>,
  ssr: SuggestionsSsr | undefined,
  listingId: string | number | undefined,
): void => {
  if (!ssr?.suggestions || listingId == null) return

  try {
    client.writeQuery({
      query: SuggestionsDocument,
      variables: { listingId, scope: 'region' },
      data: ssr.suggestions,
    })
  } catch {
    // Best-effort: a malformed payload must not break the render.
  }
}

export default seedSuggestions
